import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Layer, Attribute, MapPositionBounds } from "../../../types";
import { LayerPropertiesDefaultFeature } from "./LayerPropertiesDefaultFeature";

interface Props {
  layer: Layer;
  groupingKey: string | undefined;
  groupingCount: number | undefined;
  attributes: Attribute[];
  mapPosition: MapPositionBounds;
}

export function LayerPropertiesDefaultPrepare(props: Props) {
  const { attributes, layer, groupingKey, groupingCount, mapPosition } = props;

  const groupedAttributes = attributes.filter((attr) => attr.grouping);
  const singleAttributes = attributes.filter((attr) => !attr.grouping);

  return (
    <>
      {singleAttributes.length > 0 && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <LayerPropertiesDefaultFeature
              layer={layer}
              groupingKey={undefined}
              groupingCount={0}
              mapPosition={mapPosition}
              attributes={singleAttributes}
            />
          </Suspense>
        </ErrorBoundary>
      )}
      {groupedAttributes.length > 0 && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <LayerPropertiesDefaultFeature
              layer={layer}
              groupingKey={groupingKey}
              groupingCount={groupingCount}
              mapPosition={mapPosition}
              attributes={groupedAttributes}
            />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}
